module.exports = {
  // 本地联调不加服务名
  IMS: '/saas-core-ims',
  RIS: '/saas-core-ris',
  ECS: '/saas-core-ecs',
  BMS: '/saas-core-bms'
}
